import { createAsyncThunk } from "@reduxjs/toolkit";
import { resourceTypesByProvider } from "@/utils/helpers/providers/resourceTypesByProvider";
import { getK8SLiveUsageResourceMetadataThunk } from "@/store/kubernetes-live-usage-mgmt/thunks/resources/resource-metadata/getK8SLiveUsageResourceMetadataThunk";

export const getK8SLiveUsageAllResourcesMetadataThunk = createAsyncThunk(
  "liveUsageMgmt/getK8SLiveUsageAllResourcesMetadata",
  async (_: void, { dispatch }) => {
    const resourceTypes = resourceTypesByProvider("kubernetes");

    resourceTypes?.forEach((resourceType) => {
      dispatch(getK8SLiveUsageResourceMetadataThunk(resourceType)).unwrap();
    });
  },
);
